import axiosInstance from 'helpers/axiosInstance';

import { Patient } from './patients.type';

export interface UpdateCreditCardInfoProvidedResponse {
  patient: Patient;
}

export const updateCreditCardInfoProvided = async (
  patientId: string | string[] | undefined,
  creditCardInfoProvided: boolean,
) => {
  const url = `/patients/patients/${patientId}/credit_card_info_provided`;

  return axiosInstance
    .patch<UpdateCreditCardInfoProvidedResponse>(url, {
      creditCardInfoProvided,
    })
    .then(r => r.data);
};
